export const StringColumns = [
  "model",
  "framework",
  "framework_version",
  "model_family",
  "model_size",
  "quant",
  "gpu_type",
  "task",
  "prompt_tokens",
  "output_tokens",
  "tokens",
] as const;

export type StringColumn = (typeof StringColumns)[number];

export const Columns = [
  "model",
  "model_family",
  "model_size",
  "quant",
  "prompt_tokens",
  "output_tokens",
  "generated_tokens",
  "total_tokens",
  "tokens",
  "gpu_type",
  "gpu_count",
  "task",
  "queries_per_second",
  "ttft_mean",
  "ttft_p50",
  "ttft_p90",
  "ttft_p95",
  "itl_mean",
  "itl_p50",
  "itl_p90",
  "itl_p95",
  "ttlt_mean",
  "ttlt_p50",
  "ttlt_p90",
  "ttlt_p95",
  "framework",
  "framework_version",
  "cli_args",
  "env_vars",
  "kwargs",
] as const;

export type Column = (typeof Columns)[number];

export interface RangeCondition {
  type: "range";
  column: Column;
  maxValue: number;
}

export interface EqCondition {
  type: "eq";
  column: StringColumn;
  value: string;
}

export type FilterCondition = RangeCondition | EqCondition;

export interface Row {
  model: string;
  model_repo: string;
  model_family: string;
  model_size: string;
  tokenizer: string;
  quant: string | null;
  prompt_tokens: number;
  output_tokens: number;
  generated_tokens: number;
  total_tokens: number;
  tokens: string;
  gpu_type: string;
  gpu_count: number;
  task: string;
  queries_per_second: number;
  ttft_mean: number;
  ttft_p50: number;
  ttft_p90: number;
  ttft_p95: number;
  itl_mean: number;
  itl_p50: number;
  itl_p90: number;
  itl_p95: number;
  ttlt_mean: number;
  ttlt_p50: number;
  ttlt_p90: number;
  ttlt_p95: number;
  framework: string;
  framework_version: string;
  cli_args: string | null;
  env_vars: string | null;
  kwargs: string | null;
  rate_type: string;
}
